export default {
  fetchSuperpowers: 'superpowers/FETCH',
  fetchSuperpowersSuccess: 'superpowers/FETCH_SUCCESS',
  fetchSuperpowersFailure: 'superpowers/FETCH_FAILURE',

  findMembers: 'superpowers/FIND_MEMBERS',
  findMembersSuccess: 'superpowers/FIND_MEMBERS_SUCCESS',
  findMembersFailure: 'superpowers/FIND_MEMBERS_FAILURE',

  getMember: 'superpowers/GET_MEMBER',
  getMemberSuccess: 'superpowers/GET_MEMBER_SUCCESS',
  getMemberFailure: 'superpowers/GET_MEMBER_FAILURE',

  getDownloads: 'superpowers/GET_DOWNLOADS',
  getDownloadsSuccess: 'superpowers/GET_DOWNLOADS_SUCCESS',
  getDownloadsFailure: 'superpowers/GET_DOWNLOADS_FAILURE',

  downloadFile: 'superpowers/DOWNLOAD_FILE',
  downloadFileSuccess: 'superpowers/DOWNLOAD_FILE_SUCCESS',
  downloadFileFailure: 'superpowers/DOWNLOAD_FILE_FAILURE',
};
